import { NotificationsList } from './notifications.list';
import { NotificationsShow } from './notifications.show';

export default {
  name: 'notifications',
  options: { label: 'Notifications' },
  list: NotificationsList,
  show: NotificationsShow
};
